<template>
  <TagStatus :icon="statusData.icon" :title="statusData.title" :color="statusData.color"/>
</template>
<script setup lang="ts">
import TagStatus from "@/components/shared/TagStatus.vue";
import {computed} from "vue";
import {getStatusMessage} from "@/utils/global-utils";

const props = defineProps({
  status: {
    type: String,
    required: true,
  },

});
const statusData = computed(() => {
  return getStatusMessage(props.status);
});

</script>
<style scoped lang="scss">
ion-chip {
  margin: 0;
}
</style>
